export const LOCAL_STORAGE_KEY = 'oskari-announcements';
export const LOCAL_STORAGE_SEPARATOR = ',';
export const BUNDLE_KEY = 'announcements';
